import Organizations from '@/views/organizations/organizations.vue'
import NewOrganization from '@/views/organizations/new-organization.vue'
import ShowOrganization from '@/views/organizations/show-organization.vue'
import ShowOrganizationHistory from '@/views/organizations/show-organization-history.vue'
import OrganizationMembers from '@/views/organizations/organization-members.vue'
import { OrganizationsRouteNames } from '@/router/routes-names'
import EditMember from '@/views/members/members-show.vue'
import AddMember from '@/views/members/members-new.vue'
import NewBillingTemplate from '@/views/billing-templates/billing-templates-new.vue'
import ShowBillingTemplate from '@/views/billing-templates/billing-templates-show.vue'

export const organizationsRoutes = [
    {
        path: '/organizations',
        name: OrganizationsRouteNames.LIST,
        component: Organizations,
        props: true
    },
    {
        path: '/organizations/new',
        name: OrganizationsRouteNames.NEW,
        component: NewOrganization
    },
    {
        path: '/organizations/show/:organizationId',
        name: OrganizationsRouteNames.SHOW,
        component: ShowOrganization
    },
    {
        path: '/organizations/show-history/:organizationId',
        name: OrganizationsRouteNames.SHOW_HISTORY,
        component: ShowOrganizationHistory
    },
    {
        path: '/organizations/members/:organizationId',
        name: OrganizationsRouteNames.MEMBERS,
        component: OrganizationMembers
    },
    {
        path: '/organizations/members/:organizationId/show/:memberId',
        name: OrganizationsRouteNames.MEMBERS_SHOW,
        component: EditMember
    },
    {
        path: '/organizations/members/:organizationId/new',
        name: OrganizationsRouteNames.MEMBERS_NEW,
        component: AddMember
    },
    {
        path: '/organizations/billing-template/:organizationId/new',
        name: OrganizationsRouteNames.BILLING_TEMPLATE_NEW,
        component: NewBillingTemplate
    },
    {
        path: '/organizations/billing-template/:organizationId/show/:billingTemplateId',
        name: OrganizationsRouteNames.BILLING_TEMPLATE_SHOW,
        component: ShowBillingTemplate
    }
]
